import { useSelector } from 'react-redux';
import { selectIsProtocolPanelOpen } from 'features/stepByStepProtocol/store/stepByStepProtocolSelectors';

export function useIsProtocolPanelOpen(transactionId) {
    return useSelector((state) => selectIsProtocolPanelOpen(state, transactionId));
}
